import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { useOnBehalfSubmitter } from '../container/onBehalfContext';

export const useIsSubmitFormPage = () => {
  const location = useLocation();
  const { pathname } = location;
  // The Submissions folder submits a form on someone's behalf in a modal, so the
  // route alone does not say whether this is the submitter's view.
  const onBehalfOf = useOnBehalfSubmitter();
  return useMemo(() => {
    let value = !!onBehalfOf;
    if (pathname) {
      value = value || pathname.toLowerCase().includes('form-view');
    }
    return value;
  }, [pathname, onBehalfOf]);
};
